import { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import './Resume.css';
import { Checkbox } from '@mui/material';
import Modal from '../../components/Modal/Modal';

const API_URL = process.env.REACT_APP_API_URL;

const Resume = () => {
    const { id } = useParams();
    const numericId = parseInt(id, 10);
    const [data, setData] = useState({ activity: [], sub_activity: [] });
    const [showError, setShowError] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const userId = location.state?.userId;
    const [modalData, setModalData] = useState({
        isVisible: false,
        message: '',
        type: '',
    });

    const IsbnRegex = /^\d{13}$/;
    const dateRegex = /^(1[0-4]\d{2})[-\/](0[1-9]|1[0-2])[-\/](0[1-9]|[12]\d|3[01])$/;
    const yearRegex = /^\d{4}$/;
    const pageRegex = /^\d+$/;

    const defaultFields = {
        is_publish: { label: 'وضعیت انتشار', name: 'is_publish', value: '', checkBox: true },
        title: { label: 'عنوان', name: 'title', value: '', input: true },
    };

    const fields = {
        '1': { section: { label: 'مقطع', name: 'section', value: '' } },

        '2': { year: { label: 'سال', name: 'year', value: ''}, ISBN: { label: 'ISBN', name: 'ISBN', value: '' }, link: { label: 'لینک کتاب', name: 'link', value: '', optional: true } },

        '3': { date: { label: 'تاریخ دفاع', name: 'date', value: '', optional: true }, student_name: { label: 'نام دانشجو', name: 'student_name', value: '' } },

        '4': { date: { label: 'تاریخ دفاع', name: 'date', value: '', optional: true }, student_name: { label: 'نام دانشجو', name: 'student_name', value: '' } },

        '5': { venue: { label: 'عنوان مجله', name: 'venue', value: '' }, year: { label: 'سال', name: 'year', value: '' }, from_page: { label: 'از صفحه', name: 'from_page', value: '', optional: true }, end_page: { label: 'تا صفحه', name: 'end_page', value: '', optional: true } },

        '6': { venue: { label: 'محل برگزاری', name: 'venue', value: '' }, date: { label: 'تاریخ', name: 'date', value: '', optional: true }, authors: { label: 'نویسنده', name: 'authors', value: '' }, conference_title: { label: 'عنوان کنفرانس', name: 'conference_title', value: '' } },

        '7': { year: { label: 'سال', name: 'year', value: '' }, teammate: { label: 'همکار', name: 'teammates', value: '' } },

        '8': { venue: { label: 'محل برگزاری', name: 'venue', value: '' }, date: { label: 'تاریخ', name: 'date', value: '', optional: true } },

        '9': { start_year: { label: 'سال شروع', name: 'start_year', value: '' }, end_year: { label: 'سال پایان', name: 'end_year', value: '', optional: true } },

        '10': { venue: { label: 'محل اجرا یا ارائه', name: 'venue', value: '' }, year: { label: 'سال', name: 'year', value: '' }, teammate: { label: 'همکار', name: 'teammate', value: '' }, subject: { label: 'موضوع', name: 'subject', value: '' } },

        '11': { start_year: { label: 'سال شروع', name: 'start_year', value: '' }, end_year: { label: 'سال پایان', name: 'end_year', value: '', optional: true } },
    };

    useEffect(() => {
        const fetchData = async () => {
            const token = localStorage.getItem('token');
            try {
                const response = await fetch(`${API_URL}/resume-management/activity/` + numericId, {
                    method: "GET",
                    headers: {
                        'Authorization': `Token ${token}`,
                        "Content-Type": "application/json",
                    },
                });
                if (response.ok) {
                    const d = await response.json();
                    setData(d);
                } else {
                    const errorData = await response.json();
                    setModalData({
                        isVisible: true,
                        message: errorData.error,
                        type: 'error',
                    });
                }
            } catch (error) {
                setModalData({
                    isVisible: true,
                    message: 'مشکلی پیش آمده است. لطفا دوباره تلاش کنید',
                    type: 'error',
                });
            }
        };
        fetchData();
    }, []);

    const handleChange = (name, event, type, is_publish) => {
        if (type === 'activity') {
            if (is_publish === 'is_publish') {
                setData((prevData) => ({
                    ...prevData,
                    activity: {
                        ...prevData.activity,
                        [name]: event.target.checked,
                    },
                }));
            } else {
                setData((prevData) => ({
                    ...prevData,
                    activity: {
                        ...prevData.activity,
                        [name]: event.target.value,
                    },
                }));
            }
        } else if (type === 'sub-activity') {
            setData((prevData) => ({
                ...prevData,
                sub_activity: {
                    ...prevData.sub_activity,
                    [name]: event.target.value,
                },
            }));
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        data.activity.from_golestan = false;
        const role = localStorage.getItem('role');
        const token = localStorage.getItem('token');

        if (role === 'user') {
            try {
                const response = await fetch(`${API_URL}/resume-management/activity/` + numericId, {
                    method: 'PUT',
                    headers: {
                        'Authorization': `Token ${token}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data),
                });
                if (response.ok) {
                    setModalData({
                        isVisible: true,
                        message: 'تغییرات فعالیت با موفقیت ثبت شد',
                        type: 'success',
                    });
                    const timer = setTimeout(() => {
                        navigate('/user/activities');
                    }, 1000);
                    return () => clearTimeout(timer);
                } else {
                    setShowError(true);
                    const timer = setTimeout(() => {
                        setShowError(false);
                    }, 3000);
                    return () => clearTimeout(timer);
                }
            } catch (error) {
                setModalData({
                    isVisible: true,
                    message: 'مشکلی پیش آمده است. لطفا دوباره تلاش کنید',
                    type: 'error',
                });
            }
        } else if (role === 'admin') {
            data.user_id = userId;

            try {
                const response = await fetch(`${API_URL}/resume-management/activity/` + numericId, {
                    method: 'PUT',
                    headers: {
                        'Authorization': `Token ${token}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data),
                });
                if (response.ok) {
                    setModalData({
                        isVisible: true,
                        message: 'تغییرات فعالیت با موفقیت ثبت شد',
                        type: 'success',
                    });
                    const timer = setTimeout(() => {
                        navigate('/admin/user-management/activities/' + userId);
                    }, 1000);
                    return () => clearTimeout(timer);
                } else {
                    setShowError(true);
                    const timer = setTimeout(() => {
                        setShowError(false);
                    }, 3000);
                    return () => clearTimeout(timer);
                }
            } catch (error) {
                setModalData({
                    isVisible: true,
                    message: 'مشکلی پیش آمده است. لطفا دوباره تلاش کنید',
                    type: 'error',
                });
            }
        }
    }

    return (
        <>
            <div className="profile-container container">
                <div className="profile-card">
                    <div className="card-header">
                        <h2 className="card-title">فعالیت</h2>
                    </div>
                    <div className="card-body">
                        <form className="profile-form" onSubmit={handleSubmit}>
                            <div className="profile-row grid">
                                {Object.entries(defaultFields).map(([key, field]) => (
                                    <div key={key} className="profile-col">
                                        <label className="form-label">{field.label}</label>
                                        {field.checkBox ? (
                                            <Checkbox
                                                size="large"
                                                checked={!!data.activity?.is_publish}
                                                onChange={(event) =>
                                                    handleChange(field.name, event, 'activity', 'is_publish')
                                                }
                                            />
                                        ) : (
                                            <></>
                                        )}
                                        {field.input ? (
                                            <>
                                                <input
                                                    type="text"
                                                    name={field.name}
                                                    className="form-input"
                                                    value={typeof (data.activity
                                                    [field.name]) === 'boolean' ? data.activity[field.name].toString() : data.activity[field.name] || ''}
                                                    onChange={(event) => handleChange(field.name, event, 'activity', '')}
                                                />
                                                {(!data.activity.hasOwnProperty(field.name) || data.activity[field.name] === '') && showError && (<p className="error-text">{field.label} نمی تواند خالی باشد</p>)}
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                ))}
                                {data.activity.type_of_activity && Object.entries(fields[data.activity.type_of_activity] || {}).map(([key, field]) => (
                                    <div key={key} className="profile-col">
                                        <label className="form-label">{field.label}</label>
                                        <input
                                            type="text"
                                            name={field.name}
                                            placeholder={field.name === "date" ? "yyyy-mm-dd" : ""}
                                            className="form-input"
                                            value={typeof (data.sub_activity[field.name]) === 'boolean' ? data.sub_activity[field.name].toString() : data.sub_activity[field.name] || ''}
                                            onChange={(event) => handleChange(field.name, event, 'sub-activity', '')}
                                        />

                                        {(!data.sub_activity.hasOwnProperty(field.name) || data.sub_activity[field.name] === '') && !field?.optional && showError && (<p className="error-text">{field.label} نمی تواند خالی باشد</p>)}
                                        {!(!data.sub_activity.hasOwnProperty(field.name) || data.sub_activity[field.name] === '') && field.name === 'ISBN' && !IsbnRegex.test(data.sub_activity.ISBN) && showError && (<p className="error-text">{field.label} باید شامل ۱۳ عدد باشد</p>)}
                                        {!(!data.sub_activity.hasOwnProperty(field.name) || data.sub_activity[field.name] === '') && field.name === 'date' && !dateRegex.test(data.sub_activity.date) && showError && (<p className="error-text">فرمت تاریخ وارد شده اشتباه است</p>)}

                                        {!(!data.sub_activity.hasOwnProperty(field.name) || data.sub_activity[field.name] === '') && !yearRegex.test(data.sub_activity.year) && field.name === 'year' && showError && (<p className="error-text">{field.label} باید شامل ۴ عدد باشد</p>)}
                                        {!(!data.sub_activity.hasOwnProperty(field.name) || data.sub_activity[field.name] === '') && !yearRegex.test(data.sub_activity.start_year) && field.name === 'start_year' && showError && (<p className="error-text">{field.label} باید شامل ۴ عدد باشد</p>)}
                                        {!(!data.sub_activity.hasOwnProperty(field.name) || data.sub_activity[field.name] === '') && !yearRegex.test(data.sub_activity.end_year) && field.name === 'end_year' && showError && (<p className="error-text">{field.label} باید شامل ۴ عدد باشد</p>)}

                                        {!(!data.sub_activity.hasOwnProperty(field.name) || data.sub_activity[field.name] === '') && !pageRegex.test(data.sub_activity.from_page) && field.name === 'from_page' && showError && (<p className="error-text">صفحه باید فقط شامل عدد باشد</p>)}
                                        {!(!data.sub_activity.hasOwnProperty(field.name) || data.sub_activity[field.name] === '') && !pageRegex.test(data.sub_activity.end_page) && field.name === 'end_page' && showError && (<p className="error-text">صفحه باید فقط شامل عدد باشد</p>)}
                                    </div>
                                ))}
                            </div>
                            <div className="profile-button-container">
                                <button className="profile-button btn medium-text" type="submit">
                                    ذخیره
                                </button>
                            </div>
                        </form>
                        <Modal
                            message={modalData.message}
                            type={modalData.type}
                            isVisible={modalData.isVisible}
                            onClose={() => setModalData({ ...modalData, isVisible: false })}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Resume;
